<template>
  <div class="edit-active-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="120px">
        <el-form-item label="活动:" prop="activityId">
          <el-select v-model="params.activityId" size="small" placeholder="请选择活动" filterable clearable>
            <el-option v-for="item in actIDs" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖池模式:" prop="model">
          <el-select v-model="params.model" size="small" placeholder="请选择奖池模式" filterable clearable>
            <el-option v-for="item in models" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="当日预计收益:" prop="estimatedIncome">
          <el-input v-model.number="params.estimatedIncome" size="small" type="number" placeholder="请输入当日预计收益" clearable></el-input>
        </el-form-item>

        <el-form-item label="单次抽奖金额:" prop="price">
          <el-input v-model.number="params.price" size="small" type="number" placeholder="请输入单次抽奖金额" clearable></el-input>
        </el-form-item>

        <el-form-item label="免费次数:" prop="freeCount">
          <el-input v-model.number="params.freeCount" size="small" type="number" placeholder="请输入免费次数" clearable></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  props: {
    actIDs: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      title: "新增奖池",
      flag: false,
      type: "", //表单类型
      params: {
        activityId: "",
        model: "",
        estimatedIncome: "",
        endTime: "",
        status: false,
      },
      models: [
        {
          value: 1,
          label: "棋牌游戏",
        },
        {
          value: 2,
          label: "免费",
        },
      ],
      // 表单验证规则
      rules: {
        activityId: [
          { required: true, message: "请选择活动", trigger: "change" },
        ],
        model: [
          { required: true, message: "请选择奖池模式", trigger: "change" },
        ],
        estimatedIncome: [
          { required: true, message: "请输入当日预计收益", trigger: "blur" },
        ],
        price: [
          { required: true, message: "请输入单次抽奖金额", trigger: "blur" },
        ],
        freeCount: [
          { required: true, message: "请输入免费次数", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "edit") {
            this.editActive();
          }
          if (this.type == "add") {
            this.addContent();
          }
        } else {
          return false;
        }
      });
    },

    addContent() {
      let params = Object.assign({}, this.params);
      API.addPrizePool(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$emit("handlerList");
          } else {
            this.$message.error(res.msg || "新增失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    editActive() {
      let params = Object.assign({}, this.params);
      API.editPrizePool(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        title: "",
        desc: "",
        status: false,
        startTime: "",
        endTime: "",
      };
    },

    // 打开编辑活动弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑奖池";
        this.params = Object.assign({}, data);
      }
    },
  },
};
</script>
<style lang="scss" >
.edit-active-box {
  .el-input {
    width: 200px;
  }
  .el-dialog {
    margin-top: 50px !important;
  }
}
</style>
